import {
    Autocomplete,
    Button, Checkbox,
    Chip,
    FormControlLabel,
    Grid,
    MenuItem,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField, Tooltip,
    Typography, useTheme
} from "@mui/material";
import {useTranslation} from "react-i18next";
import SectionHeader from "../../../../util/component/SectionHeader";
import '../../style/SalesMarketing.css';
import * as Yup from 'yup';
import {useNavigate, useParams} from "react-router-dom";
import {useContext, useEffect, useMemo, useState} from "react";
import {useProductCodeActions} from "../../service/useProductCodeActions";
import BusinessAgreementCreationModal from "./modals/BusinessAgreementCreationModal";
import {
    BUSINESS_AGREEMENT_STATUS_DISMISSED,
    BUSINESS_AGREEMENT_STATUS_DRAFT,
    BUSINESS_AGREEMENT_STATUS_READY,
    DOSSIER_MANDATORY,
    DOSSIER_NOT_MANDATORY,
    INTEGER_REG_EXP, INTEGER_REG_EXP_COMMA,
    MAIL_ADDRESS_REG_EXP
} from "../../component/Constants";
import {useBusinessAgreementActions} from "../../service/useBusinessAgreementActions";
import {useStatusValuesBusinessAgreement} from "../../component/useStatusValuesBusinessAgreement";
import {Controller, useFieldArray, useForm, FormProvider} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {DeleteRounded, DoDisturbAltRounded, InfoOutlined, LibraryAddRounded} from "@mui/icons-material";
import {IconButton, Stack} from "@mui/material/";
import AddJimpyCodesModal from "./modals/AddJimpyCodesModal";
import EmptyState from "../../../../util/component/EmptyState";
import AddProductModal from "./modals/AddProductModal";
import {useStatusValuesProduct} from "../../component/useStatusValuesProduct";
import {useLookupActions} from "../../service/useLookupActions";
import AsyncAutocomplete from "../../component/AsyncAutocomplete";
import {useCustomerBaseActions} from "../../service/useCustomerBaseActions";
import {
    preselectSingleEntity,
    UserLegalEntitiesOrDealersInputGroup
} from "../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {useProcurerActions} from "../../service/useProcurerActions";
import TaxConfigurationAccordion from "../../component/TaxConfiguration/TaxConfigurationAccordion";
import OrderConfigurationAccordion from "./accordion/OrderConfigurationAccordion";
import {boolToString, floatToIntCurrency, handleChangeCustomer, intToFloatCurrency, stringToBool} from "../../component/Utils";
import {getEnumLikeObj} from './Utils'
import {usePaOrdersActions} from "../../service/usePaOrdersActions";
import { BILLING_MODES, DEPOSIT_CODES_LIST, GUARANTEE_PAYMENT_METHOD_REL, GUARANTEE_SCHEMES, INVOICE_RECIPIENTS, PAYMENT_DUE_DATES, PAYMENT_METHDOS, SEGMENT_LIST } from "../../service/SalesMarketingRecoil";
import { useRecoilState } from "recoil";


interface BusinessAgreementDetail {
    tenantId: string,
    dealerId: string,
    id: number,
    status: string,
    name: string,
    description: string,
    segmentCode: string,
    configStartDate: Date,
    configEndDate: Date,
    customerId: string,
    customerName: string,
    personName: string,
    personSurname: string,
    rentalGroup: number,
    unlimitedRentalGroup: boolean,
    preAuthCode: string,
    emailCourtesyInvoice: string[],
    vendorId: string,
    procurerId: string,
    jimpyCodes: string[],
    emailSendingVoucher?:string[],
    guarantee: string,
    paymentMethod: string,
    paymentDueDate: string,
    billingMode: string,
    firstInvoiceRecipient: string,
    subsequentInvoiceRecipient: string,
    dossier: string,
    productList: any[],
    businessCode: string,
    accountEmail: string[],
    splitPayment: string,
    taxConfiguration?: {
        railwayStationTax?: string,
        roadTax?: string,
        airportTax?: string,
        airportRailwayStationTax?: string,
        roadTaxDailyValue?: string,
        reservedPricing?: string
    },
    orderConfiguration?: any[]
}

const BusinessAgreementCreateOrUpdatePage = () => {
    const {globalData} = useContext(GlobalContext)
    const {dispatchGlobalData} = useContext(GlobalContext);
    const productCodeActions = useProductCodeActions();
    const {businessAgreementId} = useParams();
    const isUpdate = !!businessAgreementId;
    const {t} = useTranslation(['salesmarketing', 'translation']);
    const navigate = useNavigate();
    const [businessAgreement, setBusinessAgreement] = useState<BusinessAgreementDetail>();
    const [selectedCustomer, setSelectedCustomer] = useState<any>("");
    const [selectedPersonName, setSelectedPersonName] = useState<any>("");
    const [selectedPersonSurname, setSelectedPersonSurname] = useState<any>("");
    const [openAddJimpyCodesModal, setOpenAddJimpyCodesModal] = useState(false);
    const [openAddProductModal, setOpenAddProductModal] = useState(false);
    const [categoriesBySegmentCode, setCategoriesBySegmentCode] = useState<any[]>([]);
    const [segments] = useRecoilState(SEGMENT_LIST);
    const [depositList] = useRecoilState(DEPOSIT_CODES_LIST);
    const [guaranteeSchemes] = useRecoilState(GUARANTEE_SCHEMES);
    const [guaranteePaymentMethodRel] = useRecoilState(GUARANTEE_PAYMENT_METHOD_REL);
    const [paymentDueDates] = useRecoilState(PAYMENT_DUE_DATES);
    const [billingModes] = useRecoilState(BILLING_MODES);
    const [invoiceRecipients] = useRecoilState(INVOICE_RECIPIENTS);
    const [paymentMethods] = useRecoilState(PAYMENT_METHDOS);
    const {getBusinessAgreementById, createBusinessAgreement, updateBusinessAgreement} = useBusinessAgreementActions();
    const {getCategoriesBySegmentCode} = useLookupActions();
    const {getCustomerListBusinessConvention} = useCustomerBaseActions();
    const {listProcurers} = useProcurerActions();
    const {getStatusLabelAgreement} = useStatusValuesBusinessAgreement();
    const {getStatusColorProduct, getStatusLabelProduct} = useStatusValuesProduct();
    const theme = useTheme();
    const [orderList, setOrderList] = useState([])
    const {getOrders} = usePaOrdersActions();

    useEffect(()=>{
        getOrders({limit: 10000, offset: 0}).then((res :any)=> setOrderList(res.content));
    },[])


    const [openCreationModal, setOpenCreationModal] = useState(false);

    const statuses = [
        {
            key: BUSINESS_AGREEMENT_STATUS_DRAFT,
            value: getStatusLabelAgreement(BUSINESS_AGREEMENT_STATUS_DRAFT)
        },
        {
            key: BUSINESS_AGREEMENT_STATUS_READY,
            value: getStatusLabelAgreement(BUSINESS_AGREEMENT_STATUS_READY)
        },
        {
            key: BUSINESS_AGREEMENT_STATUS_DISMISSED,
            value: getStatusLabelAgreement(BUSINESS_AGREEMENT_STATUS_DISMISSED)
        }
    ]

    const dossierValues = [
        {
            key: DOSSIER_MANDATORY,
            value: getStatusLabelAgreement(DOSSIER_MANDATORY)
        },
        {
            key: DOSSIER_NOT_MANDATORY,
            value: getStatusLabelAgreement(DOSSIER_NOT_MANDATORY)
        }
    ]

   const enumLikeGuaranteeObj = useMemo(() => getEnumLikeObj(guaranteeSchemes.map(item => item.value)),[guaranteeSchemes])

   const enumLikeRecipientObj = useMemo(()=> getEnumLikeObj(invoiceRecipients.map(item => item.id)),[invoiceRecipients])

    useEffect(() => {
        // Retrieve data
        productCodeActions.listSegment();
        productCodeActions.listBillingModes();
        productCodeActions.listInvoiceRecipients();
        if (businessAgreementId && isUpdate) {
             getBusinessAgreementById(businessAgreementId).then(res => {
                if (res.customerId && res.customerName) {
                    setSelectedCustomer({value: res.customerId, label: res.customerName});
                }
                if (res.customerId && res.personName && res.personSurname) {
                    setSelectedPersonName({value: res.personName, label: res.personName});
                    setSelectedPersonSurname({value: res.personSurname, label: res.personSurname});
                }
                setBusinessAgreement(res);
             });
        }
    }, []);

    useEffect(() => {
        reset(retrieveInitialValues())
    }, [businessAgreement])

    const retrieveInitialValues = () => {
        if (isUpdate && businessAgreement) {
            return {
                tenantId: businessAgreement.tenantId ? businessAgreement.tenantId : "",
                dealerId: businessAgreement.dealerId ? businessAgreement.dealerId : "",
                id: businessAgreement.id ? businessAgreement.id : null,
                status: businessAgreement.status ? businessAgreement.status : "",
                name: businessAgreement.name ? businessAgreement.name : "",
                description: businessAgreement.description ? businessAgreement.description : "",
                segmentCode: businessAgreement.segmentCode ? businessAgreement.segmentCode : "",
                configStartDate: businessAgreement.configStartDate ? businessAgreement.configStartDate : null,
                configEndDate: businessAgreement.configEndDate ? businessAgreement.configEndDate : null,
                customerId: businessAgreement.customerId ? businessAgreement.customerId : "",
                customerName: businessAgreement.customerName ? businessAgreement.customerName : "",
                personName: businessAgreement.personName ? businessAgreement.personName : "",
                personSurname: businessAgreement.personSurname ? businessAgreement.personSurname : "",
                rentalGroup: businessAgreement.rentalGroup != null && businessAgreement.rentalGroup !== -1 ? businessAgreement.rentalGroup : "",
                unlimitedRentalGroup: businessAgreement.rentalGroup != null && businessAgreement.rentalGroup === -1,
                preAuthCode: businessAgreement.preAuthCode != null ? businessAgreement.preAuthCode : "",
                emailCourtesyInvoice: businessAgreement.emailCourtesyInvoice && Array.isArray(businessAgreement.emailCourtesyInvoice) ? businessAgreement.emailCourtesyInvoice : [],
                vendorId: businessAgreement.vendorId ? businessAgreement.vendorId : "",
                procurerId: businessAgreement.procurerId ? businessAgreement.procurerId : "",
                jimpyCodes: businessAgreement.jimpyCodes ? businessAgreement.jimpyCodes : [],
                emailSendingVoucher:businessAgreement.emailSendingVoucher ? businessAgreement.emailSendingVoucher : [],
                guarantee: businessAgreement.guarantee ? businessAgreement.guarantee : "",
                paymentMethod: businessAgreement.paymentMethod ? businessAgreement.paymentMethod : "",
                paymentDueDate: businessAgreement.paymentDueDate ? businessAgreement.paymentDueDate : "",
                billingMode: businessAgreement.billingMode ? businessAgreement.billingMode : "",
                firstInvoiceRecipient: businessAgreement.firstInvoiceRecipient ? businessAgreement.firstInvoiceRecipient : "",
                subsequentInvoiceRecipient: businessAgreement.subsequentInvoiceRecipient ? businessAgreement.subsequentInvoiceRecipient : "",
                dossier: businessAgreement.dossier ? businessAgreement.dossier : "",
                productList: businessAgreement.productList ? businessAgreement.productList : [],
                businessCode: businessAgreement.businessCode ? businessAgreement.businessCode : '',
                accountEmail: businessAgreement.accountEmail ? businessAgreement.accountEmail : [],
                splitPayment: businessAgreement.splitPayment ? stringToBool(businessAgreement.splitPayment) : false,
                taxConfiguration: {
                    railwayStationTax: businessAgreement.taxConfiguration?.railwayStationTax ? businessAgreement.taxConfiguration?.railwayStationTax : 'S',
                    roadTax: businessAgreement.taxConfiguration?.roadTax ? businessAgreement.taxConfiguration?.roadTax : 'S',
                    airportTax: businessAgreement.taxConfiguration?.airportTax ? businessAgreement.taxConfiguration?.airportTax : 'S',
                    airportRailwayStationTax: businessAgreement.taxConfiguration?.airportRailwayStationTax ? businessAgreement.taxConfiguration?.airportRailwayStationTax : '',
                    roadTaxDailyValue: businessAgreement.taxConfiguration?.roadTaxDailyValue ? intToFloatCurrency(businessAgreement.taxConfiguration?.roadTaxDailyValue) : '',
                    reservedPricing: businessAgreement.taxConfiguration?.reservedPricing ? businessAgreement.taxConfiguration?.reservedPricing : ''
                },
                orderConfiguration: businessAgreement.orderConfiguration? businessAgreement.orderConfiguration : []
            };
        } else {
            return {
                tenantId: "",
                dealerId: "",
                status: "",
                name: "",
                description: "",
                segmentCode: "",
                configStartDate: null,
                configEndDate: null,
                customerId: "",
                customerName: "",
                personName: "",
                personSurname: "",
                rentalGroup: "",
                unlimitedRentalGroup: false,
                preAuthCode: "",
                emailCourtesyInvoice: [],
                vendorId: "",
                procurerId: "",
                jimpyCodes: [],
                emailSendingVoucher:[],
                guarantee: "",
                paymentMethod: "",
                paymentDueDate: "",
                billingMode: "",
                firstInvoiceRecipient: "",
                subsequentInvoiceRecipient: "",
                dossier: "",
                productList: [],
                businessCode: '',
                accountEmail: [],
                splitPayment: false,
                taxConfiguration: {
                    railwayStationTax: "S",
                    roadTax: "S",
                    airportTax: "S",
                    airportRailwayStationTax: "",
                    roadTaxDailyValue: "",
                    reservedPricing: ""
                },
                orderConfiguration: []
            };
        }
    }


    const validationSchema = Yup.object().shape({
        tenantId: Yup.string().nullable().test('testTenant', t('salesmarketing:businessAgreement.createForm.requiredCheck'), (value) => {
            if (globalData?.user?.legalEntities?.length === 1)
                return true;
            return !!value;
        }),
        dealerId: Yup.string().nullable().test('testDealer', t('salesmarketing:businessAgreement.createForm.requiredCheck'), (value) => {
            if (globalData?.user?.dealers?.length === 1)
                return true;
            return !!value;
        }),
        status: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        customerName: Yup.string().nullable().test('at-least-one', t('salesmarketing:businessAgreement.createForm.requiredCompanyOrPerson'),
            function (value) {
                const { personName } = this.parent;
                return !!personName || !!value;
            }
        ),
        personName: Yup.string().nullable().test('at-least-one', t('salesmarketing:businessAgreement.createForm.requiredCompanyOrPerson'),
            function (value) {
                const { customerName  } = this.parent;
                return !!customerName  || !!value;
            }
        ),
        personSurname: Yup.string().nullable().test('at-least-one', t('salesmarketing:businessAgreement.createForm.requiredCompanyOrPerson'),
            function (value) {
                const { customerName  } = this.parent;
                return !!customerName  || !!value;
            }
        ),
        name: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        description: Yup.string().nullable(),
        segmentCode: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        preAuthCode: Yup.string().nullable(),
        configStartDate: Yup.date().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')).nullable()
            .test("testBookingStartDate", t('salesmarketing:businessAgreement.createForm.datesCheck'), (value, context) => {
                return (value && context.parent.configEndDate && value <= context.parent.configEndDate)
            })
            .typeError(t('salesmarketing:businessAgreement.createForm.invalidDate')),
        configEndDate: Yup.date().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')).nullable()
            .test("testBookingEndDate", t('salesmarketing:businessAgreement.createForm.datesCheck'), (value, context) => {
                return (value && context.parent.configStartDate && value >= context.parent.configStartDate)
            }).typeError(t('salesmarketing:businessAgreement.createForm.invalidDate')),
        customerId: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        rentalGroup: Yup.string().nullable().test("testRentalGroup", t('salesmarketing:businessAgreement.createForm.requiredCheck'), (value, context) => {
            return (!!value || context.parent.unlimitedRentalGroup)
        }),
        deposit: Yup.string().nullable(),
        emailCourtesyInvoice: Yup.array(Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('salesmarketing:businessAgreement.createForm.emailNotValid')
        })),
        accountEmail: Yup.array(Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('salesmarketing:businessAgreement.createForm.emailNotValid')
        })),
        vendorId: Yup.string().nullable(),
        procurerId: Yup.string().nullable(),
        emailSendingVoucher: Yup.array(Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('salesmarketing:businessAgreement.createForm.emailNotValid')
        })),
        guarantee: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        paymentMethod: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        paymentDueDate: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        billingMode: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        firstInvoiceRecipient: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        subsequentInvoiceRecipient: Yup.string(),
        dossier: Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        productList: Yup.array().of(Yup.object({
            productName: Yup.string().nullable(),
            productCode: Yup.string(),
            startDate: Yup.date(),
            endDate: Yup.date(),
            category: Yup.string(),
            status: Yup.string(),
            jimpyCode: Yup.string()
                .matches(INTEGER_REG_EXP_COMMA, {
                    message: t('salesmarketing:businessAgreement.createForm.integer'),
                    excludeEmptyString: true
                })
                .test('testPositive', t('salesmarketing:businessAgreement.createForm.integer'), (value) => {
                    if (value === '')
                        return true
                    return !!value && parseInt(value) >= 0;
                })
        })).min(0),
        businessCode: Yup.string().nullable(),
        taxConfiguration: Yup.object().shape({
            airportRailwayTaxPercentage: Yup.number().min(0).max(100),
            railwayStationTax:Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
            roadTax:Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
            airportTax:Yup.string().required(t('salesmarketing:businessAgreement.createForm.requiredCheck')),
        })
    });

    const methods = useForm({
        defaultValues: retrieveInitialValues(),
        resolver: yupResolver(validationSchema)
    });


    const {handleSubmit, control, setValue, watch, reset,formState,trigger,getValues} = methods;


    useEffect(() => {
        preselectSingleEntity(globalData, setValue);
    }, [globalData, setValue]);

    useEffect(()=> {

        if(Object.keys(enumLikeGuaranteeObj).length > 0 && Object.keys(enumLikeRecipientObj).length > 0 && !isUpdate && getValues('guarantee') === ''){
            setValue('guarantee', enumLikeGuaranteeObj.FULL_CREDIT)
            setValue('firstInvoiceRecipient',enumLikeRecipientObj.COMPANY)
            setValue('subsequentInvoiceRecipient',enumLikeRecipientObj.NA)
        }
    },[enumLikeGuaranteeObj,enumLikeRecipientObj])

    useEffect(() => {
        let selectedSegment = watch("segmentCode");
        if (selectedSegment) {
            getCategoriesBySegmentCode(selectedSegment).then(res => {
                setCategoriesBySegmentCode(res);
            })
        } else {
            setCategoriesBySegmentCode([])
        }
    }, [watch("segmentCode")])


    useEffect(() => {
        let tenantId = watch('tenantId');
        let dealerId = watch('dealerId');
        if(!isUpdate) {
            emptyFields();
        }
        if(tenantId && dealerId) {
            productCodeActions.listPaymentDueDates(tenantId, dealerId);
            productCodeActions.listGuaranteeSchemes(tenantId, dealerId);
            productCodeActions.listPaymentMethods(tenantId, dealerId);
            productCodeActions.getPreAuthorizationList(tenantId, dealerId);
        }
    }, [watch('tenantId'), watch('dealerId')]);

    function emptyFields() {
        setValue("guarantee", "")
        setValue("paymentMethod", "")
        setValue("paymentDueDate", "")
        setValue("preAuthCode", "")
    }

    function handlePersonSelection(){
        setValue("segmentCode", "COR")
        setValue('firstInvoiceRecipient',enumLikeRecipientObj.PERSON)
        setValue("customerName", "")
        setSelectedCustomer("")
    }
    function handleCompanySelection(){
        setValue('firstInvoiceRecipient',enumLikeRecipientObj.COMPANY)
        setSelectedPersonName("")
        setSelectedPersonSurname("")
        setValue("personName", "")
        setValue("personSurname", "")
    }

    function handleInvoiceReceipientOnPersonSelection(){
        if(watch("personName") !== "") {
            setValue('firstInvoiceRecipient',enumLikeRecipientObj.PERSON)
        } else {
            setValue('firstInvoiceRecipient',enumLikeRecipientObj.COMPANY)
        }
    }


    const onSubmit = async (values: any) => {
        if (checkList()) {
            let hasDuplicatesJimpyCodes = false;
            let arraySizeAccountEmail = true;
            let arraySizeVoucherEmail = true;

            let payload = {
                ...values, taxConfiguration: {
                    ...values.taxConfiguration,
                    roadTaxDailyValue: values.taxConfiguration.roadTaxDailyValue ? floatToIntCurrency(values.taxConfiguration.roadTaxDailyValue) : ''
                }
            };

            payload.customerName = selectedCustomer?.label;
            payload.personName = selectedPersonName?.label;
            payload.personSurname = selectedPersonSurname?.label;
            if (watch("unlimitedRentalGroup")) {
                payload.rentalGroup = -1;
            }
            payload.splitPayment = boolToString(values.splitPayment);


            if(payload.productList) {
               payload.productList.forEach((product:any) => {
                   if (!hasDuplicatesJimpyCodes && product.jimpyCode)
                       hasDuplicatesJimpyCodes = checkJimpyCodes(product.jimpyCode)
               });
            }

            if(payload.accountEmail){
                arraySizeAccountEmail = checkEmailSize(payload.accountEmail)
            }
            if(payload.emailSendingVoucher){
                arraySizeVoucherEmail = checkEmailSize(payload.emailSendingVoucher)
            }

            if(!hasDuplicatesJimpyCodes){
                if(arraySizeAccountEmail) {
                    if(arraySizeVoucherEmail) {
                        if (isUpdate) {
                            let data = await updateBusinessAgreement(payload);
                            if (data && data.status === 'OK') {
                                // show modal with confirm
                                setOpenCreationModal(true);
                            } else {
                                dispatchGlobalData({
                                    type: setSnackbar,
                                    payload: {
                                        snackbar: {
                                            message: t(data.code === 15 ? "salesmarketing:businessAgreement.error.jimpyCodeDuplicated" : 'salesmarketing:businessAgreement.updateForm.modalTitleSuccess'),
                                            type: snackbarTypes.error,
                                            show: true,
                                            autoClose: true,
                                        }
                                    }
                                });
                            }
                        } else {
                            if (globalData.user.legalEntities.length === 1) {
                                payload = {...payload, tenantId: globalData.user.legalEntities[0].name}
                            }

                            if (globalData.user.dealers.length === 1) {
                                payload = {...payload, dealerId: globalData.user.dealers[0].name}
                            }

                            let data = await createBusinessAgreement(payload);
                            if (data && data.status === 'OK') {
                                // show modal with confirm
                                setOpenCreationModal(true);
                            } else {
                                dispatchGlobalData({
                                    type: setSnackbar,
                                    payload: {
                                        snackbar: {
                                            message: t(data.code === 15 ? "salesmarketing:businessAgreement.error.jimpyCodeDuplicated" : 'salesmarketing:businessAgreement.createForm.modalTitleSuccess'),
                                            type: snackbarTypes.error,
                                            show: true,
                                            autoClose: true,
                                        }
                                    }
                                });

                            }
                        }
                    } else {
                        dispatchGlobalData({
                            type: setSnackbar,
                            payload: {
                                snackbar: {
                                    message: t( "salesmarketing:businessAgreement.error.voucherEmailLengthNotValid" ),
                                    type: snackbarTypes.error,
                                    show: true,
                                    autoClose: true,
                                }
                            }
                        });
                    }
                } else {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: t( "salesmarketing:businessAgreement.error.accountEmailLengthNotValid" ),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true,
                            }
                        }
                    });
                }
            } else {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t( "salesmarketing:businessAgreement.error.jimpyCodeDuplicatedError" ),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            }
        }
    }

    function checkList() {
        let result = {isOk: true};
        return result.isOk;
    }

    function checkJimpyCodes(jimpyCodes: any) {
        return hasDuplicates( jimpyCodes.split(","));
    }

    function checkEmailSize(emails: any) {
        return emails.reduce((acc: any, currentValue: any) => acc + currentValue.length, 0) < 1000;
    }
    function hasDuplicates(iterable: any) {
        return  new Set(iterable).size !== iterable.length;
    }

    const {fields:productList, append:appendProducts, remove:removeProducts} = useFieldArray({control, name: "productList"});

    const {fields:ordersList, append:appendOrdersList, remove:removeOrdersList} = useFieldArray({control, name: 'orderConfiguration'});


    return (
        <>
            <SectionHeader
                title={t(isUpdate ? 'salesmarketing:businessAgreement.updateHeader.title' : 'salesmarketing:businessAgreement.createHeader.title')}
                subtitle={t('salesmarketing:businessAgreement.createHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                <FormProvider {...methods} >
                    <form onSubmit={handleSubmit(data => {
                        onSubmit(data);
                    }, errors => console.log(errors))} noValidate>
                        <Grid container rowSpacing={3} columnSpacing={3} alignItems={'flex-end'}>
                            <UserLegalEntitiesOrDealersInputGroup
                                control={control}
                                disabled={isUpdate}
                            />
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"businessCode"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            disabled
                                            name="businessCode"
                                            label={t('salesmarketing:businessAgreement.businessCode')}
                                            InputProps={{
                                                endAdornment: isUpdate ? <></> : <Tooltip
                                                    title={t('businessAgreement.businessCodeTooltip')}><InfoOutlined
                                                    color="primary"/></Tooltip>
                                            }}
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={9}/>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"status"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="status"
                                            label={t('salesmarketing:businessAgreement.status')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {statuses?.map((a) => (
                                                <MenuItem key={a.key} value={a.key}>
                                                    {a.value}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"segmentCode"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            disabled={watch("productList").length > 0 || watch("tenantId") === "" || watch("dealerId") === ""}
                                            required
                                            name="segmentCode"
                                            label={t('salesmarketing:businessAgreement.segment')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {segments?.map((a) => (
                                                <MenuItem key={a.segmentCode} value={a.segmentCode}>
                                                    {a.segmentName}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={6}/>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"customerName"}
                                    render={({field, fieldState}) => (
                                        <AsyncAutocomplete id={"customerName"}
                                            value={selectedCustomer} otherFilters={""}
                                            callback={getCustomerListBusinessConvention}
                                            onChange={(value) => {
                                                handleChangeCustomer(value,setSelectedCustomer,setValue,trigger,formState)
                                                field.onChange(value ? value.label : "")
                                                handleCompanySelection()
                                            }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                required={!!watch("customerName") || (!watch("personName") && !watch("personSurname"))}
                                                label={t('salesmarketing:businessAgreement.customerName')}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            />}
                                />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"personName"}
                                    render={({field, fieldState}) => (
                                        <AsyncAutocomplete id={"personName"}
                                                           value={selectedPersonName}
                                                           otherFilters={watch("personSurname")}
                                                           callback={getCustomerListBusinessConvention}
                                                           onChange={(value) => {
                                                               handleChangeCustomer(value, setSelectedPersonName, setValue, trigger, formState)
                                                               handlePersonSelection()
                                                               field.onChange(value ? value.label : "")
                                                           }}
                                                           renderInput={(params) => <TextField
                                                               {...params}
                                                               required={!!watch("personName")}
                                                               label={t('salesmarketing:businessAgreement.personName')}
                                                               error={!!fieldState.error}
                                                               helperText={fieldState.error?.message}
                                                           />}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"personSurname"}
                                    render={({field, fieldState}) => (
                                        <AsyncAutocomplete id={"personSurname"}
                                                           value={selectedPersonSurname}
                                                           otherFilters={watch("personName")}
                                                           callback={getCustomerListBusinessConvention}
                                                           onChange={(value) => {
                                                               handleChangeCustomer(value, setSelectedPersonSurname, setValue, trigger, formState)
                                                               handlePersonSelection()
                                                               field.onChange(value ? value.label : "")
                                                           }}
                                                           renderInput={(params) => <TextField
                                                               {...params}
                                                               required={!!watch("personName")}
                                                               label={t('salesmarketing:businessAgreement.personSurname')}
                                                               error={!!fieldState.error}
                                                               helperText={fieldState.error?.message}
                                                           />}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"customerId"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            disabled
                                            name="customerId"
                                            label={t('salesmarketing:businessAgreement.customerId')}
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"configStartDate"}
                                    render={({field, fieldState}) => (
                                        <DatePicker
                                            label={t('salesmarketing:businessAgreement.startDate')}
                                            value={field.value}
                                            onChange={field.onChange}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    required
                                                    fullWidth
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}/>
                                            }
                                            inputFormat={"L"}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"configEndDate"}
                                    render={({field, fieldState}) => (
                                        <DatePicker
                                            label={t('salesmarketing:businessAgreement.endDate')}
                                            value={field.value}
                                            onChange={field.onChange}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    required
                                                    fullWidth
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}/>
                                            }
                                            inputFormat={"L"}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"name"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="name"
                                            label={t('salesmarketing:businessAgreement.name')}
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"description"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            name="description"
                                            label={t('salesmarketing:businessAgreement.description')}
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Stack direction={"row"} columnGap={2} alignItems={"baseline"}>
                                    <Controller
                                        control={control}
                                        name={"rentalGroup"}
                                        render={({field, fieldState}) => (
                                            <TextField
                                                fullWidth
                                                name="rentalGroup"
                                                required={!watch("unlimitedRentalGroup")}
                                                disabled={watch("unlimitedRentalGroup")}
                                                placeholder={watch("unlimitedRentalGroup") ? "--" : ""}
                                                label={t('salesmarketing:businessAgreement.listColumns.rentalGroup')}
                                                value={field.value}
                                                onChange={(e) => {
                                                    if (e.target.value === "" || INTEGER_REG_EXP.test(e.target.value)) {
                                                        field.onChange(e);
                                                    }
                                                }}
                                                InputLabelProps={{shrink: true}}
                                                error={!!fieldState.error}
                                                helperText={fieldState.error?.message}
                                            />
                                        )}/>
                                    <Controller
                                        control={control}
                                        name={"unlimitedRentalGroup"}
                                        render={({field, fieldState}) => (
                                            <FormControlLabel
                                                sx={{marginLeft: "0px"}}
                                                control={
                                                    <Switch sx={{margin: "5px"}} checked={field.value}
                                                            onChange={(e) => {
                                                                field.onChange(e);
                                                                setValue("rentalGroup", "");
                                                            }}
                                                            name="unlimitedRentalGroup"/>
                                                }
                                                label={t('salesmarketing:businessAgreement.unlimitedRentalGroup')}
                                                labelPlacement="end"
                                            />
                                        )}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"preAuthCode"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            name="preAuthCode"
                                            label={t('salesmarketing:businessAgreement.deposit')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {depositList?.map((a) => (
                                                <MenuItem key={a.id} value={a.id}>
                                                    {a.description}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"vendorId"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            name="vendorId"
                                            label={t('salesmarketing:businessAgreement.vendorId')}
                                            value={field.value}
                                            onChange={(e) => {
                                                if (e.target.value === "" || INTEGER_REG_EXP.test(e.target.value)) {
                                                    field.onChange(e);
                                                }
                                            }}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"procurerId"}
                                    render={({field, fieldState}) => (
                                        <AsyncAutocomplete
                                            id="procurerId"
                                            value={field.value}
                                           // onChange={field.onChange}
                                            onChange={(newVal:any) => {
                                                let val = newVal ? newVal.split(' -')[0] : '' ;
                                                field.onChange(val)
                                            }}
                                            callback={async (val: string) => {
                                                let res = await listProcurers({
                                                    offset: 0,
                                                    limit: 1000,
                                                    genBpCode: val
                                                });
                                                if (res.content && res.content.length > 0)
                                                    return res.content.map((p: any) => `${p.genBpCode} - ${p.repCompanyName}`).sort();
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('salesmarketing:businessAgreement.procurerId')}
                                                    error={!!fieldState.error}
                                                    helperText={fieldState.error?.message}
                                                />
                                            )}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={6}>
                            <Controller
                                control={control}
                                name={"emailCourtesyInvoice"}
                                render={({field, fieldState: {error}}) => (
                                    <Autocomplete
                                        multiple
                                        clearOnBlur={true}
                                        blurOnSelect={false}
                                        freeSolo
                                        id="emailCourtesyInvoice"
                                        options={[]}
                                        value={field.value}
                                        onChange={(e, newVal, reason) => field.onChange(newVal)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={t('salesmarketing:businessAgreement.emailCourtesyInvoice')}
                                                placeholder={t('salesmarketing:chipList.placeholder')}
                                                error={!!error}
                                                helperText={error && (error as unknown as Array<any>)[0] ? (error as unknown as Array<any>)[0].message : ""}
                                            />
                                        )}
                                    />
                                )}/>
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    control={control}
                                    name={"accountEmail"}
                                    render={({field, fieldState: {error}}) => (
                                        <Autocomplete
                                            multiple
                                            clearOnBlur={true}
                                            blurOnSelect={false}
                                            freeSolo
                                            id="accountEmail"
                                            options={[]}
                                            value={field.value}
                                            onChange={(e, newVal, reason) => field.onChange(newVal)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('salesmarketing:businessAgreement.accountEmail')}
                                                    placeholder={t('salesmarketing:chipList.placeholder')}
                                                    error={error !== undefined}
                                                    helperText={error && (error as unknown as Array<any>)[0] ? (error as unknown as Array<any>)[0].message : ""}
                                                />
                                            )}
                                        />
                                    )}/>
                            </Grid>
                            <Grid item xs={6}>
                            <Controller
                                control={control}
                                name={"emailSendingVoucher"}
                                render={({field, fieldState:{error}}) => (
                                    <Autocomplete
                                            multiple
                                            clearOnBlur={true}
                                            blurOnSelect={false}
                                            freeSolo
                                            id="emailSendingVoucher"
                                            options={[]}
                                            value={field.value}
                                            onChange={(e, newVal, reason) => field.onChange(newVal)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={t('salesmarketing:businessAgreement.emailSendingVoucher')}
                                                    placeholder={t('salesmarketing:chipList.placeholder')}
                                                    error={!!error}
                                                    helperText={error && (error as unknown as Array<any>)[0] ? (error as unknown as Array<any>)[0].message : ""}
                                                />
                                            )}
                                        />
                                )}/>
                            </Grid>
                            <Grid item xs={6}/>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"guarantee"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="guarantee"
                                            label={t('salesmarketing:businessAgreement.guarantee')}
                                            select
                                            value={field.value}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                if(e.target.value !== ''){
                                                    if(e.target.value === enumLikeGuaranteeObj.NO_CREDIT){
                                                        setValue('firstInvoiceRecipient',enumLikeRecipientObj.CUSTOMER)
                                                        setValue('subsequentInvoiceRecipient',enumLikeRecipientObj.NA)
                                                    } else if(e.target.value === enumLikeGuaranteeObj.FULL_CREDIT){
                                                        handleInvoiceReceipientOnPersonSelection()
                                                        setValue('subsequentInvoiceRecipient',enumLikeRecipientObj.NA)
                                                    } else {
                                                        handleInvoiceReceipientOnPersonSelection()
                                                        setValue('subsequentInvoiceRecipient',enumLikeRecipientObj.CUSTOMER)
                                                    }
                                                }
                                            }}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            {guaranteeSchemes?.map((a) => (
                                                <MenuItem key={a.value} value={a.value}>
                                                    {a.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"paymentMethod"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            disabled={!watch("guarantee")}
                                            name="paymentMethod"
                                            label={t('salesmarketing:businessAgreement.paymentMethod')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {guaranteePaymentMethodRel?.find(g => g.code === watch("guarantee"))?.paymentMethodCodes.map((method) => {
                                                    let pm = paymentMethods.find(pm => pm.value === method);
                                                    return pm ? <MenuItem key={pm.label} value={pm.value}>
                                                        {pm.label}
                                                    </MenuItem> : null;
                                            })}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"paymentDueDate"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="paymentDueDate"
                                            label={t('salesmarketing:businessAgreement.paymentDueDate')}
                                            select
                                            disabled={watch("tenantId") === "" || watch("dealerId") === ""}
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {paymentDueDates?.map((a) => (
                                                <MenuItem key={a.value} value={a.value}>
                                                    {a.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"billingMode"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="billingMode"
                                            label={t('salesmarketing:businessAgreement.billingMode')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {watch("guarantee") === "NO_CREDIT" ?
                                                billingModes?.filter(b => b.value === "S").map((a) => (
                                                    <MenuItem key={a.value} value={a.value}>
                                                        {a.label}
                                                    </MenuItem>))
                                                :
                                                billingModes?.map((a) => (
                                                    <MenuItem key={a.value} value={a.value}>
                                                        {a.label}
                                                    </MenuItem>
                                                ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"firstInvoiceRecipient"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="firstInvoiceRecipient"
                                            label={t('salesmarketing:businessAgreement.firstInvoiceRecipient')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            disabled={watch('personName') !== '' ? false : watch('guarantee') !== ''}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {invoiceRecipients?.map((a) => (
                                                <MenuItem key={"firstInv" + a.id} value={a.id}>
                                                    {a.recipientType}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"subsequentInvoiceRecipient"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            name="subsequentInvoiceRecipient"
                                            label={t('salesmarketing:businessAgreement.subsequenceInvoiceRecipient')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                            disabled={watch('guarantee') !== ''}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {invoiceRecipients?.map((a) => (
                                                <MenuItem key={"subseqInv" + a.id} value={a.id}>
                                                    {a.recipientType}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"dossier"}
                                    render={({field, fieldState}) => (
                                        <TextField
                                            fullWidth
                                            required
                                            name="dossier"
                                            label={t('salesmarketing:businessAgreement.dossier')}
                                            select
                                            value={field.value}
                                            onChange={field.onChange}
                                            error={!!fieldState.error}
                                            helperText={fieldState.error?.message}
                                        >
                                            <MenuItem key={""} value={""}/>
                                            {dossierValues?.map((a) => (
                                                <MenuItem key={a.key} value={a.key}>
                                                    {a.value}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}/>
                            </Grid>
                            <Grid item xs={3}>
                                <Controller
                                    control={control}
                                    name={"splitPayment"}
                                    render={({field, fieldState}) => (
                                        <FormControlLabel
                                            label={t('salesmarketing:businessAgreement.splitPayment')}
                                            control={<Checkbox
                                                color={"accent"}
                                                sx={{color: theme.palette.accent.main}}
                                                checked={field.value}
                                                onChange={field.onChange}
                                            />}
                                        />
                                    )}/>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{marginTop: '50px'}}>
                            <TaxConfigurationAccordion prefix={'taxConfiguration'}/>
                        </Grid>
                        <Grid item xs={12} sx={{marginTop: '32px'}}>
                            <OrderConfigurationAccordion orders={orderList} fields={ordersList}
                                                         append={appendOrdersList} remove={removeOrdersList}/>
                        </Grid>
                        <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                            <Grid item>
                                <Typography>{t('salesmarketing:businessAgreement.products.title')}</Typography>
                            </Grid>
                            <Grid item container alignItems={"center"}>
                                <Grid item xs={12}>
                                    <Button
                                        sx={{float: "right"}}
                                        disabled={categoriesBySegmentCode.length === 0}
                                        variant={"text"} color={"accent"}
                                        endIcon={<LibraryAddRounded/>} onClick={() => setOpenAddProductModal(true)}>
                                        {t('salesmarketing:businessAgreement.products.addProduct')}
                                    </Button>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {productList.length === 0 ?
                                    <EmptyState icon={<DoDisturbAltRounded/>}
                                                title={t('salesmarketing:businessAgreement.products.noValuesTitle')}
                                                content={t('salesmarketing:businessAgreement.products.noValuesContent')}/>
                                    :
                                    <TableContainer>
                                        <Table aria-label="productList-table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>{t('salesmarketing:businessAgreement.products.name')}</TableCell>
                                                    <TableCell>{t('salesmarketing:businessAgreement.products.code')}</TableCell>
                                                    <TableCell>{t('salesmarketing:businessAgreement.products.startDate')}</TableCell>
                                                    <TableCell>{t('salesmarketing:businessAgreement.products.endDate')}</TableCell>
                                                    <TableCell>{t('salesmarketing:businessAgreement.products.category')}</TableCell>
                                                    <TableCell>{t('salesmarketing:businessAgreement.products.jimpyCode')}</TableCell>
                                                    <TableCell
                                                        align={"center"}>{t('salesmarketing:businessAgreement.products.status')}</TableCell>
                                                    <TableCell
                                                        align={"center"}>{t('salesmarketing:businessAgreement.products.delete')}</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {productList.map((row: any, index: number) => (
                                                    <TableRow key={row.id}>
                                                        <TableCell>{row.productName ? row.productName : ""}</TableCell>
                                                        <TableCell>{row.productCode ? row.productCode : ""}</TableCell>
                                                        <TableCell>{row.startDate ? dayjs(row.startDate).format("L") : ""}</TableCell>
                                                        <TableCell>{row.endDate ? dayjs(row.endDate).format("L") : ""}</TableCell>
                                                        <TableCell>{row.category ? row.category : ""}</TableCell>
                                                        <TableCell>
                                                            <Controller
                                                                control={control}
                                                                name={`productList.${index}.jimpyCode`}
                                                                render={({field, fieldState}) => (
                                                                    <TextField
                                                                        required
                                                                        value={field.value}
                                                                        onChange={field.onChange}
                                                                        error={!!fieldState.error}
                                                                        helperText={fieldState.error?.message}
                                                                    />
                                                                )}
                                                            />
                                                        </TableCell>
                                                        <TableCell align={"center"}>{row.status ?
                                                            <Chip label={getStatusLabelProduct(row.status)}
                                                                  sx={{backgroundColor: getStatusColorProduct(row.status)}}/>
                                                            : ""}
                                                        </TableCell>
                                                        <TableCell align={"center"}>
                                                            <IconButton
                                                                color={"accent"}
                                                                aria-label="delete"
                                                                onClick={() => removeProducts(index)}
                                                            >
                                                                <DeleteRounded/>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                            </Grid>
                        </Grid>
                        <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                            <Grid container item xs={12} rowSpacing={1} columnSpacing={3} justifyContent={"flex-end"}>
                                <Grid item>
                                    <Button variant={"outlined"} color={"accent"}
                                            onClick={() => {
                                                navigate("/salesmarketing/businessagreementlist")
                                            }}>
                                        {t('salesmarketing:businessAgreement.buttons.cancel')}
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button color={"accent"}
                                            type="submit">{t('salesmarketing:businessAgreement.buttons.confirm')}</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </FormProvider>
            </Paper>
            <BusinessAgreementCreationModal isUpdate={isUpdate} open={openCreationModal}
                                            handleCloseCreationModal={() => setOpenCreationModal(false)}/>
            <AddJimpyCodesModal open={openAddJimpyCodesModal} handleClose={() => setOpenAddJimpyCodesModal(false)}
                                watch={watch} setValue={setValue}/>
            {openAddProductModal &&
                <AddProductModal tenantId={watch("tenantId")} dealerId={watch("dealerId")} open={openAddProductModal} handleClose={() => setOpenAddProductModal(false)}
                                 checkDatesOverlap={watch('segmentCode') !== 'TOP'} filterProducts={false}
                                 categories={categoriesBySegmentCode} append={appendProducts} fields={productList}/>}
        </>
    );
}

export default BusinessAgreementCreateOrUpdatePage;